import { useMemo } from 'react'
import { useAccessControl } from '../../../../context/AccessControlContext'

const useUserPermissionsDetailed = () => {
  const { permissions, loading, refresh, isSuperAdmin } = useAccessControl()
  const user = useMemo(() => JSON.parse(localStorage.getItem('user') || '{}'), [])

  const allPermissionsList = useMemo(
    () =>
      Object.keys(permissions || {}).filter(
        (key) => key !== '__superAdmin' && permissions[key] === true
      ),
    [permissions]
  )

  const userPermissions = useMemo(
    () => ({
      permissions,
      allPermissionsList,
      __superAdmin: isSuperAdmin,
      roles: [],
      directPermissions: allPermissionsList.map((code) => ({ code, name: code })),
      userInfo: {
        id: user.id,
        name: user.fullname || user.login,
        email: user.email,
        role: user.role,
      },
    }),
    [permissions, allPermissionsList, isSuperAdmin, user]
  )

  return {
    userPermissions,
    permissionsLoading: loading,
    error: null,
    refetch: refresh,
  }
}

export default useUserPermissionsDetailed
